import { wardrobeItem } from '@/Interfaces/common';

export const rodCaps = [
    {
        name: 'grc_left',
        height: 0.1,
        width: 0.1,
        depth: 0.1,
    } as wardrobeItem,
    {
        name: 'grc_right',
        height: 0.1,
        width: 0.1,
        depth: 0.1,
    } as wardrobeItem,
];

// export const defaultRodsOffsets = [ 0,-0.089,0.2676 ] as const;
